/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static _STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static _MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    try {
      let viewedProducts = this.getProducts();

      viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
      viewedProducts.unshift(productId);
      viewedProducts = viewedProducts.slice(0, RecentlyViewed._MAX_PRODUCTS);

      localStorage.setItem(RecentlyViewed._STORAGE_KEY, JSON.stringify(viewedProducts));
    } catch (e) {
      // localStorage may be unavailable in incognito mode
    }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(RecentlyViewed._STORAGE_KEY);
    } catch (e) {
      // localStorage may be unavailable in incognito mode
    }
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    try {
      return JSON.parse(localStorage.getItem(RecentlyViewed._STORAGE_KEY) || '[]');
    } catch (e) {
      // localStorage may be unavailable in incognito mode
      return [];
    }
  }
}
